<div class="flex border-b border-solid border-black-200 overflow-hidden p-3 items-center bg-white dark:bg-gray-900">
    @if (buttons !== null) {
        @if (buttons?.backButton !== null) {
            <button (click)="buttons?.backButton.onClick()" class="mr-3 flex items-center h-11">
                <je-fa-icon [name]="'angle-left'"></je-fa-icon>
            </button>
        }
    }
    @if (showOrderInformation && orderInformation) {
        <div class="flex text-sm items-center">
            @if (orderInformation?.hasLinkedOrders) {
                <button
                    (click)="onOrderLinkClicked()"
                    class="w-[34px] text-black-900 m-2 bg-blue-400 rounded flex items-center justify-center float-right h-11"
                    jeTooltip="{{ 'ORDER_LINK.DIALOG.TITLE' | translate }}"
                    type="button">
                    <je-fa-icon [name]="'link'"></je-fa-icon>
                </button>
            }
            <div class="mr-3">
                <div class="font-bold text-blue flex items-center gap-1">
                    {{ orderInformation.orderNumber }}
                    @if (orderInformation.supplementCount) {
                        <span> ({{ orderInformation.supplementCount }}) </span>
                    }
                </div>
                <div>{{ orderState }}</div>
            </div>
            <div class="hidden lg:block mr-3 max-w-64 xl:max-w-full">
                <div>{{ orderInformation.customerName }}</div>
                <div class="truncate">
                    {{ orderInformation.productName }}
                </div>
                <div>
                    @if (orderInformation.licensePlate && orderInformation.vehicleIdentificationNumber) {
                        {{ orderInformation.licensePlate }} |
                        {{ orderInformation.vehicleIdentificationNumber }}
                    } @else if (orderInformation.vehicleIdentificationNumber) {
                        {{ orderInformation.vehicleIdentificationNumber }}
                    } @else if (orderInformation.licensePlate) {
                        {{ orderInformation.licensePlate }}
                    }
                </div>
            </div>
        </div>
    } @else if (showProductInformation && productInformation) {
        <div class="mr-3 font-bold">
            {{ headlineTranslationKey | translate }}
        </div>
        <div class="flex flex-col text-sm">
            <div>{{ productInformation.customerName }}</div>
            <div class="truncate">{{ productInformation.productName }} ({{ productInformation.version }})</div>
        </div>
    } @else {
        <div class="mr-3 font-bold">
            {{ headlineTranslationKey | translate }}
        </div>
    }
    <div class="flex-grow flex-row ml-auto items-center flex justify-end">
        @if (buttons !== null && !isTeamOrder) {
            <je-split-button></je-split-button>
            @if (buttons?.primaryButton) {
                <je-button variant="primary" [label]="buttons.primaryButton.label | translate" [disabled]="isPrimaryButtonDisabled" (onClick)="buttons?.primaryButton.onClick()">
                </je-button>
            }
        }
    </div>
</div>
